export default "__VITE_ASSET__9fe291c2__"